import { forwardRef, type InputHTMLAttributes } from 'react';
import { cn } from '../../lib/utils';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, label, error, id, ...props }, ref) => {
    return (
      <div className="space-y-1.5">
        {label && (
          <label htmlFor={id} className="block text-sm font-medium text-[color:var(--ink-base)]">
            {label}
          </label>
        )}
        <input
          ref={ref}
          id={id}
          className={cn(
            'block w-full rounded-[1.15rem] border border-[color:var(--surface-line)] bg-[var(--surface-panel-strong)] px-4 py-2.5 text-sm text-[color:var(--ink-strong)] shadow-[var(--shadow-soft)] transition-all placeholder:text-[color:var(--ink-soft)] focus:border-[color:var(--surface-line-strong)] focus:outline-none focus:ring-2 focus:ring-[color:var(--surface-focus)] disabled:cursor-not-allowed disabled:opacity-60',
            error && 'border-error focus:border-error focus:ring-error',
            className,
          )}
          {...props}
        />
        {error && <p className="text-xs text-error">{error}</p>}
      </div>
    );
  },
);

Input.displayName = 'Input';
